import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LightLanding from "@/pages/LightLanding";
import SuccessPage from "@/pages/SuccessPage";
import ShareIndex from "@/pages/ShareIndex";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LightLanding />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/share" element={<ShareIndex />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
